// extracted by css-extract-rspack-plugin
export default {"StyledAnchor":"Dp_oZ"};